import React, { Fragment, useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from '../../components/Help-Desk-Components/Footer/Footer';
import icon1 from "../../images/icon/Buga/secret-file.png";
import icon2 from "../../images/icon/Buga/faq.png";
import icon3 from "../../images/icon/Buga/generalfaq.png";
import icon4 from "../../images/icon/Buga/headphones.png";
import icon5 from "../../images/icon/Buga/file-protection.png";
import sIcon from "../../images/icon/Buga/arrow-black.svg";
import HeaderBuga from "../../components/header6/Header6";

const HelpUs = () => {
       const { pathname } = useLocation();
    useLayoutEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <HeaderBuga />
        <section
          className="page-title pt-100  pos-rel bg_img breadcrums-bgr"
        //   style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap ">
               <div className="row mt-none-30 align-items-center text-center">
                <div className="col-xl-12 col-lg-8 mt-30">
                  <div className="page-title-box">
                    <h2 className="title">Help</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="service pt-25 pb-130">
          <div className="container">
            <div className="row mt-none-30 justify-content-center d-flex">

              {/* KYC Upload */}
              <div className="col-lg-4 col-md-6 mt-30">
                <div className="service-box">
                  <div className="service-item">
                    <div className="xb-item--holder mb-85">
                      <h3 className="xb-item--title">KYC Upload</h3>
                      <span className="xb-item--contact">
                        Quick, secure, and fully compliant with international remittance standards. 
                      </span>
                    </div>
                    <div className="xb-item--icon ul_li_between">
                      <div className="xb-item--img">
                        <img src={icon1} style={{width: '100px', height: '100px'} } alt="KYC Upload" />
                      </div>
                      <Link
                        to="/kycupload"
                        className="xb-item--arrow"
                      >
                        <img src={sIcon} alt="arrow" />
                      </Link>
                    </div>
                    <Link
                      to="/kycupload"
                      className="xb-overlay"
                    ></Link>
                  </div>
                </div>
              </div>

              {/* Onboarding FAQs */}
              <div className="col-lg-4 col-md-6 mt-30">
                <div className="service-box">
                  <div className="service-item">
                    <div className="xb-item--holder mb-85">
                      <h3 className="xb-item--title">Onboarding FAQs</h3>
                      <span className="xb-item--contact">
                        Your Questions Answered – Start Sending Money with Confidence
                      </span>
                    </div>
                    <div className="xb-item--icon ul_li_between">
                      <div className="xb-item--img">
                        <img src={icon2} style={{width: '100px', height: '100px'} } alt="Onboarding FAQs" />
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to="/onboardingFAQ"
                        className="xb-item--arrow"
                      >
                        <img src={sIcon} alt="arrow" />
                      </Link>
                    </div>
                    <Link
                      onClick={ClickHandler}
                      to="/onboardingFAQ"
                      className="xb-overlay"
                    ></Link>
                  </div>
                </div>
              </div>

              {/* Data Safety */}
              <div className="col-lg-4 col-md-6 mt-30">
                <div className="service-box">
                  <div className="service-item">
                    <div className="xb-item--holder mb-85">
                      <h3 className="xb-item--title">Data Safety</h3>
                      <span className="xb-item--contact">
                        At Bugamoney, safeguarding your information is our highest priority.
                      </span>
                    </div>
                    <div className="xb-item--icon ul_li_between">
                      <div className="xb-item--img">
                        <img src={icon5} alt="Data Safety" />
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to="/datasafty"
                        className="xb-item--arrow"
                      >
                        <img src={sIcon} alt="arrow" />
                      </Link>
                    </div>
                    <Link
                      onClick={ClickHandler}
                      to="/datasafty"
                      className="xb-overlay"
                    ></Link>
                  </div>
                </div>
              </div>

              {/* General FAQs */}
              <div className="col-lg-4 col-md-6 mt-30">
                <div className="service-box">
                  <div className="service-item">
                    <div className="xb-item--holder mb-85">
                      <h3 className="xb-item--title">General FAQs</h3>
                      <span className="xb-item--contact">
                        Frequently Asked Questions
                      </span>
                    </div>
                    <div className="xb-item--icon ul_li_between">
                      <div className="xb-item--img">
                        <img src={icon3 } style={{width: '100px', height: '100px'} } alt="General FAQs" />
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to="/generalFaq"
                        className="xb-item--arrow"
                      >
                        <img src={sIcon} alt="arrow" />
                      </Link>
                    </div>
                    <Link
                      onClick={ClickHandler}
                      to="/generalFaq"
                      className="xb-overlay"
                    ></Link>
                  </div>
                </div>
              </div>

              {/* Contact Info */}
              <div className="col-lg-4 col-md-6 mt-30">
                <div className="service-box">
                  <div className="service-item">
                    <div className="xb-item--holder mb-85">
                      <h3 className="xb-item--title">Contact Info</h3>
                      <span className="xb-item--contact">
                        Need Help? We’re Here for You.
                      </span>
                    </div>
                    <div className="xb-item--icon ul_li_between">
                      <div className="xb-item--img">
                        <img src={icon4} style={{width: '100px', height: '100px'} } alt="Contact Info" />
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to="/contact"
                        className="xb-item--arrow"
                      >
                        <img src={sIcon} alt="arrow" />
                      </Link>
                    </div>
                    <Link
                      onClick={ClickHandler}
                      to="/contact"
                      className="xb-overlay"
                    ></Link>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

      </div>
     
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default HelpUs;
